import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Dataskyddspolicy = lazy(() => import("@/pages/info/Dataskyddspolicy"));

export const Route = createFileRoute("/dataskyddspolicy")({
  head: () => seoHead("/dataskyddspolicy", { description: "Vi värnar om din integritet. Här förklarar vi vilka personuppgifter vi behandlar, varför, hur länge de sparas och vilka rättigheter du har enligt GDPR." }),
  component: () => <Dataskyddspolicy />,
});
